<template>
  <h5 v-if="!showElectoralAlliances">Mandatfordeling</h5>
  <h5 v-if="showElectoralAlliances">Mandatfordeling med valgforbund</h5>

  <p v-if="!threshold">Beregnet uden spærregrænse.</p>

  <p v-if="threshold">Spærregrænse: {{ threshold }}%</p>

  <table class="table table-striped">
    <thead>
      <tr>
        <th>Parti/liste</th>
        <th v-if="showElectoralAlliances" class="text-right">Antal stemmer</th>
        <th class="text-center">Mandater</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="item in items" v-bind:key="item.id">
        <td>{{ item.party }} ({{ item.partyLetter }})</td>
        <td v-if="showElectoralAlliances" class="text-right">
          {{ item.votes }}
        </td>
        <td class="text-center">{{ item.seats }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'SimpleResult',
  props: {
    items: Array,
    showElectoralAlliances: Boolean,
    threshold: Number,
  },
  components: {},
  data: function() {
    return {};
  },
  methods: {},
};
</script>

<style scoped></style>
